/* eslint-disable @typescript-eslint/ban-ts-comment */
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { globalQueryClient } from 'queries/queryClient'

import { QUERIES } from '@/enums/queries'
import type { Packet, PacketQuery, PacketResponse } from '@/types/packet'

import { getPacket, getPackets } from './services/loadPackets'

export const useLoadPackets = (
  params: PacketQuery,
  options: Omit<
    UseQueryOptions<
      PacketResponse,
      Error,
      PacketResponse,
      (string | PacketQuery)[]
    >,
    'queryKey' | 'queryFn'
  > = {}
): UseQueryResult<PacketResponse, Error> => {
  return useQuery({
    // @ts-ignore
    queryKey: [QUERIES.PACKETS.LIST, params],
    queryFn: ({ signal }) => {
      return getPackets(params, { signal })
    },
    ...options,
  })
}

export const useLoadPacket = (
  id: string,
  options: Omit<
    UseQueryOptions<Packet, Error, Packet, string[]>,
    'queryKey' | 'queryFn'
  > = {}
): UseQueryResult<Packet, Error> => {
  return useQuery({
    // @ts-ignore
    queryKey: [QUERIES.PACKETS.GET, id],
    queryFn: () => {
      return getPacket(id)
    },
    ...options,
  })
}

export const invalidateLoadPackets = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.PACKETS.LIST],
    exact: false,
  })

  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.PACKETS.GET],
    exact: false,
  })
}

export const invalidateLoadPacket = async () => {
  await globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.PACKETS.GET],
    exact: false,
  })
}
